var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1000005950(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2295 9.08847e-05H1.77049C1.30629 -0.0046333 0.859174 0.174984 0.52725 0.499529C0.195326 0.824074 0.00570713 1.26704 0 1.73123V22.2727C0.00673925 22.7362 0.196812 23.1782 0.528624 23.5019C0.860435 23.8256 1.30696 24.0046 1.77049 23.9999H22.2295C22.6937 24.0036 23.1406 23.8234 23.4723 23.4986C23.8041 23.1739 23.9938 22.731 24 22.2668V1.72532C23.9917 1.2625 23.8011 0.821646 23.4696 0.49859C23.138 0.175535 22.6924 -0.00361171 22.2295 9.08847e-05Z",
    fill: "#0076B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94959 8.37602H7.0947V21.73H2.94959V8.37602ZM5.02329 1.72998C5.49872 1.72998 5.96346 1.87117 6.35873 2.13568C6.754 2.40019 7.06203 2.77614 7.24387 3.21597C7.4257 3.65581 7.47316 4.13976 7.38024 4.6066C7.28732 5.07344 7.0582 5.50221 6.72187 5.83864C6.38553 6.17508 5.95709 6.40408 5.49075 6.49667C5.0244 6.58926 4.54111 6.54128 4.102 6.3588C3.6629 6.17632 3.28771 5.86754 3.02391 5.47152C2.76011 5.0755 2.61954 4.61004 2.62 4.13401C2.6206 3.49621 2.87407 2.88474 3.32471 2.43397C3.77535 1.98319 4.38629 1.72998 5.02329 1.72998ZM9.69484 8.37602H13.6683V10.2094H13.7232C14.2771 9.1598 15.6275 8.05289 17.644 8.05289C21.8418 8.04372 22.62 10.8098 22.62 14.3964V21.73H18.4749V15.2329C18.4749 13.686 18.4474 11.6945 16.3211 11.6945C14.1947 11.6945 13.8331 13.3812 13.8331 15.1321V21.73H9.69484V8.37602Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000005950);
export default __webpack_public_path__ + "static/media/Group 1000005950.e85bc24f8f0013eb50a3b40781bdc883.svg";
export { ForwardRef as ReactComponent };